@import '../../../../styles/teamscale_tables';

@grid-template-columns: 1fr max-content max-content max-content;

.checkbox-filters:global(.ui.list)[role='list'] {
	width: 100%;
	margin-bottom: 1em;
	padding: 4px 0;
	box-shadow: none;
	display: grid;
	grid-template-columns: @grid-template-columns;

	:global(.header.item) {
		margin: 0;
		line-height: @baseLineHeight;
		font-weight: 700;

		&:not(:first-child) {
			margin-top: 20px;
			border-bottom: 1px solid @tableBorder;
		}
	}
}

.grid-template-columns {
	grid-template-columns: @grid-template-columns;
}

.subgrid-all-columns {
	display: grid !important;
	grid-template-columns: subgrid;
	grid-column: 1 / -1;
}

.grid-all-columns {
	display: grid !important;
	grid-column: 1 / -1;
}

.finding-group:global(.item) {
	align-items: flex-start;
	margin: 4px 0 0 0;

	& > :global(.checkbox) {
		&:not(.empty-checkbox) {
			max-width: 1em;
		}

		&.empty-checkbox {
			font-weight: 600;
		}

		margin-right: 0.6em;
	}

	.finding-group-accordion {
		width: 100%;
	}

	:global(.title) {
		padding: 0 !important;
		color: rgba(0, 0, 0, 0.87) !important;
		background: transparent !important;
		font-weight: 600 !important;
		width: 100%;
		border-top: 0 !important;

		.title-text {
			margin-left: 3px;
			text-indent: -3px;
		}

		:global(.dropdown.icon) {
			margin-right: 0 !important;
		}

		> :global(.item__text) {
			color: @tsText;
		}

		&:hover {
			background-color: color-mix(in srgb, @tsLightGrey 90%, black);
		}

		&.active {
			background-color: @tsLightGrey;
		}

		&.hidden {
			display: none;
		}
	}

	:global(.content) {
		margin-bottom: 0;
		padding-bottom: 0;
		padding-left: 0 !important;
		padding-right: 0;
	}
}

.finding-category-items:global(.ui.accordion.item)[role='listitem'] {
	box-shadow: none;
	margin: 0;
	padding-top: 3px;
	padding-bottom: 3px;

	:global(.list) {
		padding-left: 0;
		padding-top: 0;
		width: 100%;
	}
}

.finding-type {
	&:first-child {
		margin-top: 0.5rem;
	}
	overflow-wrap: break-word;
	margin: 0.25em 0;
	padding-left: 1.15rem;
}

.finding-summaries-count {
	text-align: right;
	display: grid;
	grid-template-columns: subgrid;
	grid-column: span 3 / span 3;

	span {
		align-self: center;
		justify-self: end;
		margin-right: 0.25rem;
	}
}
